import { Component, Input, OnChanges, Output, EventEmitter, OnInit, OnDestroy, SimpleChanges } from '@angular/core';
import { ObjectUtil } from 'app/utils/object.util';
import { CmsAlarms } from 'app/models/monitor/cms-alarms.model';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { ReplaySubject } from 'rxjs';
import { AlarmsService } from 'app/shared/services/alarms-service/alarms.service';
import { Alarms } from 'app/models/monitor/alarms.model';
import { ButtonStateService } from 'app/shared/services/buttonstate/button-state.service';
@Component({
    selector: 'app-alarms',
    templateUrl: './alarms.component.html',
    styleUrls: ['./alarms.component.scss'],
    standalone: false
})
export class AlarmsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() alarms: Alarms;
  @Input() cmsAlarms: CmsAlarms;
  @Input() overviewHeight: number
  @Output() alarmTypeChanged = new EventEmitter<any>();

  public buttons = ['ALARMS.TURBINE_ALARMS', 'ALARMS.ALARMS_CMS'];
  public counts = [0, 0];
  public source = 'alarms';
  public options = ['ALARMS.OPEN', 'ALARMS.ALL_ALARMS'];
  public label = 0;
  public active = 0;
  public isCardExpanded = false;

  private unsubscriber = new ReplaySubject();

  constructor(
    private route: ActivatedRoute,
    private alarmService: AlarmsService,
    private buttonStateService: ButtonStateService
  ) { }

  public ngOnInit(): void {
    this.checkActiveAlarms();
    this.changeSizes(5000);
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.refreshCounts();
    if (changes.overviewHeight) {
      this.changeSizes();
    }
  }

  public changeSizes(time = 2000){
    if (document.getElementById('overviewId')?.offsetHeight) { 
      setTimeout(() => {
        if (document.getElementById('alarms')) {
          document.getElementById('alarms').style.maxHeight = document.getElementById('overviewId')?.offsetHeight + 'px' ;
          if(document.getElementById('overviewId')?.offsetHeight < 300) {
            document.getElementById('alarms').style.maxHeight = '300px' ;
          }
        }
      }, time)
    }
  }

  private refreshCounts(): void {
    this.counts = [
      ObjectUtil.getProperty(this.alarms, 'alarms.length', 0),
      ObjectUtil.getProperty(this.cmsAlarms, 'alarms.length', 0)
    ];
  }
  public handleAlarmTypeChange(index: number): void {
    this.alarmTypeChanged.emit({option: this.options[index]});
    this.label = index;
    this.refreshCounts();
    this.changeButtons(this.options[index]);
    this.changeSizes();
  }

  public changeButtons(option: string) {
    switch (option) {
      case 'ALARMS.ALL_ALARMS':
        this.buttons = ['ALARMS.TURBINE_ALARMS', 'ALARMS.ALARMS_CMS'];
        break;
      case 'ALARMS.OPEN':
        this.buttons = ['ALARMS.TURBINE_ALARMS', 'ALARMS.ALARMS_CMS'];
        break;
      default:
        break;
    }
  }

  public changeTab(index: number): void {
    this.active = index;
    this.setValuesPerAlarm(this.buttons[index]);
    this.changeSizes();
  }

  private checkActiveAlarms(): void {
    this.route.queryParams.pipe(
      takeUntil(this.unsubscriber),
    ).subscribe(params => {
      if (!!params.alarms === false && this.alarmService.isStarted()) {
        this.source = this.alarmService.getValues().source;
        this.active = this.alarmService.getValues().active;
      }
      if (params.alarms) {
        switch (params.alarms) {
          case 'alarms':
            this.setValuesPerAlarm('ALARMS.OPEN');
            break;
          case 'cms':
            this.setValuesPerAlarm('ALARMS.ALARMS_CMS');
            break;
        }
      }
    });
  }

  public setValuesPerAlarm(source): void {
    switch (source) {
      case 'ALARMS.TURBINE_ALARMS':
        this.source = 'alarms';
        this.active = 0;
        this.alarmService.setSource(this.source, 0);
        break;
      case 'ALARMS.ALARMS_CMS':
        this.source = 'cms';
        this.active = 1;
        this.alarmService.setSource(this.source, 1);
        break;
    }
  }

  public onCardFullScreenChanged(event: any): void {
    this.isCardExpanded = event;
  }

  public ngOnDestroy(): void {
    this.unsubscriber.next(true);
    this.unsubscriber.complete();
  }

}


